var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrafica01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1138.696 135.286",
    style: {
      enableBackground: "new 0 0 1138.696 135.286"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grafica_01"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "742.652,16.764 723.13,0 698.261,0 718.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "706.652,16.764 687.13,0 662.261,0 682.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "670.652,16.764 651.13,0 626.261,0 646.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "634.652,16.764 615.13,0 590.261,0 610.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "598.652,16.764 579.13,0 554.261,0 574.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "562.652,16.764 543.13,0 518.261,0 538.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "527.652,16.764 508.13,0 483.261,0 503.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "494.652,16.764 475.13,0 450.261,0 470.652,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "462.87,16.764 443.348,0 419.478,0 438.87,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "424.13,16.764 404.609,0 379.739,0 400.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "388.13,16.764 368.609,0 343.739,0 364.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "352.13,16.764 332.609,0 307.739,0 328.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "316.13,16.764 296.609,0 271.739,0 292.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "280.13,16.764 260.609,0 235.739,0 256.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "244.13,16.764 224.609,0 199.739,0 220.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "209.13,16.764 189.609,0 164.739,0 185.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "176.13,16.764 156.609,0 131.739,0 152.13,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "144.348,16.764 124.826,0 100.957,0 120.348,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "108.174,16.764 88.652,0 63.783,0 84.174,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "75.174,16.764 55.652,0 30.783,0 51.174,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "43.391,16.764 23.87,0 0,0 19.391,16.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "1030.348,24.609 1138.696,135.286 1138.696,115.301 1038.87,10.217 929.565,10.217  944.513,24.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "920.435,10.217 745.435,10.217 753.326,16.543 892.391,16.543 901.065,25.565  935.891,25.565  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrafica01);
export default __webpack_public_path__ + "static/media/Grafica01.85f988095207954a016aceb16ccb8ee4.svg";
export { ForwardRef as ReactComponent };